import { Box, Container, Typography, Fade, Slide } from "@mui/material";

const steps = [
  {
    num: 1,
    title: "Escolha seu evento",
    desc: "Navegue pela vitrine e encontre o evento certo para você.",
  },
  {
    num: 2,
    title: "Selecione seu ingresso",
    desc: "Escolha o tipo de ingresso e confira os detalhes antes de pagar.",
  },
  {
    num: 3,
    title: "Pague com transparência",
    desc: "Pix, crédito ou débito. Parcelamento em até 3x sem juros no crédito.",
  },
];

export default function HowItWorks() {
  return (
    <Box sx={{ py: { xs: 6, md: 7 } }} id="como">
      <Container maxWidth={false} sx={{ maxWidth: "1120px", px: 2 }}>
        {/* HEADER */}
        <Slide direction="up" in timeout={600}>
          <Box sx={{ mb: 3 }}>
            <Fade in timeout={800}>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 900,
                    letterSpacing: "-0.01em",
                    mb: 1,
                  }}
                >
                  Como funciona
                </Typography>

                <Typography
                  sx={{
                    maxWidth: "60ch",
                    opacity: 0.75,
                    lineHeight: 1.6,
                  }}
                >
                  Do clique ao ingresso: simples para o público, profissional
                  para o organizador.
                </Typography>
              </Box>
            </Fade>
          </Box>
        </Slide>

        {/* STEPS */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(3, 1fr)",
            },
            gap: 2,
          }}
        >
          {steps.map((step, idx) => (
            <Slide key={step.num} direction="up" in timeout={600 + idx * 120}>
              <Fade in timeout={800 + idx * 120}>
                <Box
                  sx={{
                    border: "1px solid var(--linha)",
                    background: "rgba(255,255,255,0.04)",
                    borderRadius: "26px",
                    p: 2.5,
                    boxShadow: "0 10px 40px rgba(0,0,0,0.24)",
                  }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      mb: 1.5,
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 900,
                      border: "1px solid var(--linha)",
                      background: "rgba(255,255,255,0.06)",
                    }}
                  >
                    {step.num}
                  </Box>

                  <Typography sx={{ fontWeight: 900, mb: 1 }}>
                    {step.title}
                  </Typography>

                  <Typography sx={{ opacity: 0.72, lineHeight: 1.6 }}>
                    {step.desc}
                  </Typography>
                </Box>
              </Fade>
            </Slide>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
